import React, { useRef } from 'react';
import { BannerProps } from '../types';
import { BannerImage } from './banner-image';
import { AdLabel } from './ad-label';
import { useIntersectionObserve } from 'common/hooks/use-intersection-observe';
import { BannerAdLabelStyles } from '../styles';
import { prepareTargetUrl } from '../utils';

export const Banner: React.FC<BannerProps> = props => {
  const { ord, pictureUrl, targetUrl, targetBlank, onClick, onView } = props;

  const ref = useRef<HTMLAnchorElement | null>(null);

  const link = prepareTargetUrl(targetUrl, ord);

  const handleView = () => {
    if (onView) onView();
  };

  useIntersectionObserve(ref, handleView, { threshold: 0.5 });

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <>
      <a ref={ref} href={link} target={targetBlank ? '_blank' : undefined} onClick={handleClick}>
        <BannerImage {...{ pictureUrl }} />
      </a>
      {ord && <AdLabel className={BannerAdLabelStyles} {...{ ord }} />}
    </>
  );
};
